import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Settings from "./pages/Settings";
import GetHelp from "./pages/GetHelp";
import Payables from "./pages/Payables/Payables";
import Receivables from "./pages/Receivables/Receivables";
import Users from "./pages/Users";
import Items from "./pages/Items";

// Accounts
import GLAccounts from "./pages/Accounts/GLAccounts";
import GLAccountSubTypes from "./pages/Accounts/GLAccountSubTypes";
import Journals from "./pages/Accounts/Journals";
import PostingKey from "./pages/Accounts/PostingKey";
import Bank from "./pages/Accounts/Bank";
import Checkbook from "./pages/Accounts/Checkbook";

// Maintenance
import BillingType from "./pages/Maintenance/BillingType";
import BusinessArea from "./pages/Maintenance/BusinessArea";
import Company from "./pages/Maintenance/Company";
import CreditTerm from "./pages/Maintenance/CreditTerm";
import DistributionChannel from "./pages/Maintenance/DistributionChannel";
import DocumentType from "./pages/Maintenance/DocumentType";
import Industry from "./pages/Maintenance/Industry";
import PaymentMethod from "./pages/Maintenance/PaymentMethod";
import PurchasingGroup from "./pages/Maintenance/PurchasingGroup";
import PurchasingOrg from "./pages/Maintenance/PurchasingOrg";
import SalesOrg from "./pages/Maintenance/SalesOrg";
import TaxationCode from "./pages/Maintenance/TaxationCode";

// Partners
import Customers from "./pages/Partners/Customers";
import Vendors from "./pages/Partners/Vendors";

//Reports
import BankReconciliation from "./pages/Reports/BankReconciliation";
import CheckVoucher from "./pages/Reports/CheckVoucher";
import CustomerLedger from "./pages/Reports/CustomerLedger";
import DeliveryReport from "./pages/Reports/DeliveryReport";
import FinancialStatement from "./pages/Reports/FinancialStatement";
import JournalVoucher from "./pages/Reports/JournalVoucher";
// import OtherPayableVoucherForServices from "./pages/Reports/OtherPayableVoucherForServices";
import OutgoingPaymentVoucher from "./pages/Reports/OutgoingPaymentVoucher";
import PurchaseOrderReport from "./pages/Reports/PurchaseOrderReport";
import PurchaseRegister from "./pages/Reports/PurchaseRegister";
import SalesOrderReport from "./pages/Reports/SalesOrderReport";
import SalesRegister from "./pages/Reports/SalesRegister";
import StatementOfAccount from "./pages/Reports/StatementOfAccount";
import VendorLedger from "./pages/Reports/VendorLedger";
import WorkingTrialBalance from "./pages/Reports/WorkingTrialBalance";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("isAuthenticated") === "true"
  );

  const PrivateRoute = ({ children }) => {
    return isAuthenticated ? children : <Navigate to="/login" />;
  };

  return (
    <Router>
      <Routes>
        {/* LOGIN PAGE */}
        <Route path="/login" element={<Login isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />} />

        {/* PROTECTED ROUTES */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="payables" element={<Payables />} />
          <Route path="receivables" element={<Receivables />} />
          <Route path="settings" element={<Settings />} />
          <Route path="getHelp" element={<GetHelp />} />

          {/* Accounts */}
          <Route path="chartOfAccounts" element={<GLAccounts />} />
          <Route path="accountTypes" element={<GLAccountSubTypes />} />
          <Route path="bank" element={<Bank />} />
          <Route path="checkbook" element={<Checkbook />} />
          <Route path="journals" element={<Journals type={"GJ"}/>} />
          <Route path="postingKeys" element={<PostingKey />} />
          
          {/* Maintenance */}
          <Route path="billingType" element={<BillingType />} />
          <Route path="businessArea" element={<BusinessArea />} />
          <Route path="company" element={<Company />} />
          <Route path="creditTerm" element={<CreditTerm />} />
          <Route path="distributionChannel" element={<DistributionChannel />} />
          <Route path="documentType" element={<DocumentType />} />
          <Route path="industry" element={<Industry />} />
          <Route path="paymentMethod" element={<PaymentMethod />} />
          <Route path="purchasingGroup" element={<PurchasingGroup />} />
          <Route path="purchasingOrg" element={<PurchasingOrg />} />
          <Route path="salesOrg" element={<SalesOrg />} />
          <Route path="taxationCode" element={<TaxationCode />} />

          {/* Partners */}
          <Route path="customers" element={<Customers />} />
          <Route path="vendors" element={<Vendors />} />

          {/* Reports */}
          <Route path="bankReconciliation" element={<BankReconciliation />} />
          <Route path="checkVoucher" element={<CheckVoucher />} />
          <Route path="customerLedger" element={<CustomerLedger />} />
          <Route path="deliveryReport" element={<DeliveryReport />} />
          <Route path="financialStatement" element={<FinancialStatement />} />
          <Route path="journalVoucher" element={<JournalVoucher />} />
          {/* <Route path="otherPayableVoucherForServices" element={<OtherPayableVoucherForServices />} /> */}
          <Route path="outgoingPaymentVoucher" element={<OutgoingPaymentVoucher />} />
          <Route path="purchaseOrderReport" element={<PurchaseOrderReport />} />
          <Route path="purchaseRegister" element={<PurchaseRegister />} />
          <Route path="salesOrderReport" element={<SalesOrderReport />} />
          <Route path="salesRegister" element={<SalesRegister />} />
          <Route path="statementOfAccount" element={<StatementOfAccount />} />
          <Route path="vendorLedger" element={<VendorLedger />} />
          <Route path="workingTrialBalance" element={<WorkingTrialBalance />} />

          <Route path="items" element={<Items />} />

          <Route path="users" element={<Users />} />

        </Route>
      </Routes>
    </Router>
  );
}

export default App;
